import { render, staticRenderFns } from "./TwitchPlayer.vue?vue&type=template&id=5a310740&scoped=true&"
import script from "./TwitchPlayer.vue?vue&type=script&lang=js&"
export * from "./TwitchPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TwitchPlayer.vue?vue&type=style&index=0&id=5a310740&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a310740",
  null
  
)

export default component.exports